import { JOURNEY_BUILDER } from 'constants/actionTypes';

export const addStep = payload => ({
  type: JOURNEY_BUILDER.STEPS.ADD,
  payload,
});

export const updateStep = payload => ({
  type: JOURNEY_BUILDER.STEPS.UPDATE,
  payload,
});

export const removeStep = payload => ({
  type: JOURNEY_BUILDER.STEPS.REMOVE,
  payload,
});

export const reorderSteps = payload => ({
  type: JOURNEY_BUILDER.STEPS.REORDER,
  payload,
});

export const showEditDetails = () => ({
  type: JOURNEY_BUILDER.UI.SHOW_EDIT_DETAILS,
});

export const hideEditDetails = () => ({
  type: JOURNEY_BUILDER.UI.HIDE_EDIT_DETAILS,
});

export const updateJourneyDetails = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_DETAILS,
  payload,
});

export const updateJourneyStatus = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_JOURNEY_STATUS,
  payload,
});

export const updateAutosavedAt = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_AUTOSAVE,
  payload,
});

export const updateBanner = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.BANNER,
  payload,
});

export const displayBanner = payload => ({
  type: JOURNEY_BUILDER.UI.DISPLAY_BANNER,
  payload,
});

export const hideBanner = () => ({
  type: JOURNEY_BUILDER.UI.HIDE_BANNER,
});

export const updatePublished = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_PUBLISHED,
  payload,
});

export const updateFields = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_FIELDS,
  payload,
});

export const toggleFinishingEditing = payload => ({
  type: JOURNEY_BUILDER.UI.TOGGLE_FINISH_EDITING,
  payload,
});

export const showDeleteConfirmationModal = () => ({
  type: JOURNEY_BUILDER.UI.SHOW_DELETE_CONFIRMATION_MODAL,
});

export const hideDeleteConfirmationModal = () => ({
  type: JOURNEY_BUILDER.UI.HIDE_DELETE_CONFIRMATION_MODAL,
});
